export default function addMarkup(state, action) {
  const { id, updates } = action
  const markup = state.map.markups.find(m => m.id === id)

  if (!markup) return state

  return Object.assign({}, state, {
    map: {
      ...state.map,
      markups: [
        ...state.map.markups.filter(m => m.id !== id),
        {
          ...markup,
          ...updates
        }
      ]
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateMarkup.js